import ProblemSelector from "../components/problemSelector";
import Navbar from "../components/navbar";
import SiteFooter from "../components/siteFooter";
import "./select-problem.css";
import { useEffect, useMemo, useState } from "react";

function SelectProblem() {
    const problems = useMemo(
        () => [
            { problemName: "boggle", concepts: "String Manipulation", difficulty: "Hard" },
            { problemName: "bananas", concepts: "Arrays", difficulty: "Medium" },
            { problemName: "rail_tickets", concepts: "Dynamic Programming", difficulty: "Hard" },
        ],
        [],
    );

    const categories = useMemo(() => {
        const set = new Set(problems.map((p) => p.concepts));
        return Array.from(set).sort((a, b) => a.localeCompare(b));
    }, [problems]);

    // Unselected by default; only filter when one+ categories are selected.
    const [selectedCategories, setSelectedCategories] = useState(() => new Set());

    // If categories change, drop any selected values that no longer exist.
    useEffect(() => {
        setSelectedCategories((prev) => {
            if (prev.size === 0) return prev;
            const valid = new Set(categories);
            const next = new Set(Array.from(prev).filter((c) => valid.has(c)));
            return next;
        });
    }, [categories]);

    const isAllSelected = selectedCategories.size === categories.length;

    const toggleCategory = (c) => {
        setSelectedCategories((prev) => {
            const next = new Set(prev);
            if (next.has(c)) next.delete(c);
            else next.add(c);
            return next;
        });
    };

    const toggleAll = () => {
        setSelectedCategories((prev) => {
            if (categories.length === 0) return prev;
            // If all are selected, clear all. Otherwise, select all.
            return prev.size === categories.length ? new Set() : new Set(categories);
        });
    };

    const visibleProblems = useMemo(() => {
        if (selectedCategories.size === 0) return problems;
        return problems.filter((p) => selectedCategories.has(p.concepts));
    }, [problems, selectedCategories]);

    return (
        <div className="select">
            <Navbar />

            <div className="select__content">
                <header className="select__header">
                    <div className="select__title">Problem Bank</div>
                    <div className="select__subtitle">Click on a problem below to get started!</div>
                </header>

                <main className="select__main">
                    <div className="select__filters" aria-label="Problem category filters">
                        <div className="select__filtersLabel">Categories</div>
                        <div className="select__pills" role="group" aria-label="Categories">
                            <button
                                type="button"
                                className={`select__pill ${isAllSelected ? "select__pill--active" : ""}`}
                                onClick={toggleAll}
                                aria-pressed={isAllSelected}
                            >
                                All
                            </button>
                            {categories.map((c) => {
                                const active = selectedCategories.has(c);
                                return (
                                    <button
                                        key={c}
                                        type="button"
                                        className={`select__pill ${active ? "select__pill--active" : ""}`}
                                        onClick={() => toggleCategory(c)}
                                        aria-pressed={active}
                                    >
                                        {c}
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    <div className="select__list" aria-label="Problem list">
                        {visibleProblems.map((p) => (
                            <ProblemSelector
                                key={p.problemName}
                                problemName={p.problemName}
                                concepts={p.concepts}
                                difficulty={p.difficulty}
                            />
                        ))}
                    </div>

                    <div className="select__addNewWrap">
                        <a
                            className="select__addNewButton"
                            href="https://github.com/ace-n/blahaj-app"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Add New Question
                        </a>
                    </div>
                </main>

                <SiteFooter variant="minimal" />
            </div>
        </div>
    );
}

export default SelectProblem;